// Server-backed key-value settings (SQLite via /api/app-settings).
// Use this instead of localStorage when the value must be shared across origins
// (e.g. http://localhost:3000 and http://192.168.11.50:3000).

export async function getAppSetting(key: string): Promise<string | null> {
  const res = await fetch(`/api/app-settings?key=${encodeURIComponent(key)}`, {
    cache: 'no-store',
  });
  if (!res.ok) return null;
  const data = (await res.json()) as { value: string | null };
  return data.value;
}

async function putAppSetting(key: string, value: string): Promise<void> {
  const res = await fetch('/api/app-settings', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key, value }),
  });
  if (!res.ok) {
    const detail = (await res.json().catch(() => null)) as { message?: string } | null;
    throw new Error(detail?.message ?? `設定を保存できませんでした (HTTP ${res.status})`);
  }
}

/**
 * 設定を保存する。保存できなければ reject する。
 *
 * 呼び出し側の多くは `void setAppSetting(...)` の投げっぱなしなので、
 * ここで一度だけ握り潰しの handler を付けておく。こうすると
 *   - 投げっぱなしの呼び出しは unhandledrejection にならない
 *   - `.catch()` / `await` を付けた呼び出しには従来どおり失敗が届く
 * の両方が成り立つ (`p.catch()` は p 自身を「処理済み」にするだけで、
 * p に後から付ける handler は普通に呼ばれる)。
 * 失敗を完全に黙らせないよう、コンソールにも残す。
 */
export function setAppSetting(key: string, value: string): Promise<void> {
  const p = putAppSetting(key, value);
  p.catch((e: unknown) => {
    console.warn('[appSettings] 保存に失敗しました', key, e);
  });
  return p;
}
